module.exports = __webpack_public_path__ + "static/media/kingswood_entrance.481fefe8.jpg";